import * as React from "react";

import { ShiftCheckbox } from "@/components/ui/shift-checkbox";

interface Props {
  children: React.ReactNode;
  isAllSelected: boolean;
  isPartiallySelected: boolean;
  onToggleSelectAll?: () => void;
}

export const DriveTable: React.FC<Props> = ({ children, isAllSelected, isPartiallySelected, onToggleSelectAll }) => (
  <div data-testid="drive-table-scroll" className="max-w-full overflow-x-auto rounded-lg">
    <section
      className="min-w-[36rem] overflow-hidden rounded-lg border border-desert-sand-200 bg-white xl:min-w-[84rem]"
      role="table"
      aria-label="Documents"
    >
      <div
        role="row"
        className="hidden grid-cols-[2rem_minmax(16rem,1.5fr)_8rem_6rem_2rem] items-center gap-3 border-b border-desert-sand-200 bg-ivory-mist-400 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600 md:grid xl:grid-cols-[2rem_minmax(16rem,1fr)_9rem_7rem_7rem_minmax(34rem,auto)_2rem]"
      >
        <span role="columnheader">
          {onToggleSelectAll && (
            <ShiftCheckbox
              aria-label="Select all documents"
              aria-checked={isPartiallySelected ? "mixed" : isAllSelected}
              checked={isAllSelected}
              onCheckedChange={onToggleSelectAll}
              data-testid="select-all-checkbox"
            />
          )}
        </span>
        <span role="columnheader">Name</span>
        <span role="columnheader">Owner</span>
        <span role="columnheader">Access</span>
        <span role="columnheader" className="hidden xl:block">
          Created
        </span>
        <span role="columnheader" className="hidden text-center xl:block">
          Actions
        </span>
        <span aria-hidden="true" />
      </div>
      <div role="rowgroup" className="divide-y divide-desert-sand-200">
        {children}
      </div>
    </section>
  </div>
);
